module.exports = __webpack_public_path__ + "img/Apvertise-white-Logo.2c56d252.svg";